import styled from 'styled-components';

import { TextButton } from '@xingternal/button';
import {
  mediaTiny,
  mediaConfined,
  mediaXWide,
} from '@xingternal/layout-tokens';
import {
  spaceL,
  spaceXXL,
  space4XL,
  scale010,
  scale020,
  scale100,
  scale140,
  scale150,
  scale180,
  scale190,
  scale220,
  scale230,
  scale300,
  scale410,
  xdlColorBackgroundSecondary,
  scale050,
} from '@xingternal/tokens';
import { Headline, Hero } from '@xingternal/typography';
import { Column, Row } from '@xingternal/xing-grid';

export const StyledSection = styled.section`
  background: ${xdlColorBackgroundSecondary};
  margin-bottom: ${scale190};
  padding: calc(${scale010} + ${scale150}) 0 ${space4XL} ${scale100};

  @media ${mediaConfined} {
    padding: calc(${scale020} + ${scale220}) 0 calc(${scale230} - ${scale010});
  }
`;

export const Title = styled(Hero)`
  @media ${mediaConfined} {
    margin-bottom: ${scale050};
  }
`;

export const Subtitle = styled(Headline)`
  font-weight: 400;
`;

export const UpperContainer = styled.div`
  margin-bottom: ${spaceXXL};

  @media ${mediaConfined} {
    display: flex;
    margin-bottom: ${scale180};
  }
`;

export const HideButtons = styled.div`
  &&& {
    button {
      display: none;
    }
  }
`;

export const CarouselControls = styled.div`
  &&& {
    margin-top: ${scale140};
    margin-left: -${scale100};
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;

    @media ${mediaConfined} {
      margin: 0;
      width: auto;
      margin-left: ${scale300};
    }

    @media ${mediaXWide} {
      margin-left: ${scale410};
    }
  }
`;

export const CarouselButtonsWrapper = styled.div`
  display: flex;
  gap: ${spaceL};
  margin: auto;
`;

export const CarouselButton = styled(TextButton)`
  min-width: 30px;
`;

export const StyledRow = styled(Row)`
  @media ${mediaTiny} {
    &&& {
      padding: 0;
    }
  }
`;

export const StyledColumn = styled(Column)`
  @media ${mediaConfined} {
    &&& {
      padding: 0;
    }
  }
`;
